export default __webpack_public_path__ + "static/snowflake_w.13f24afca6c0343d5964f05e3d14d0f7.svg";